Ext.define('SA.HistogramFrameSizeResolver', {
    statics: {
        resolve({cfg, data}) {
            var resolver = new SA.HistogramFrameSizeResolver({cfg, data}),
                width = resolver.resolveWidth(),
                height = resolver.resolveHeight();

            return {width, height};
        }
    },

    constructor({cfg, data}) {
        this.cfg = cfg;

        this.trialFrameSize = {width: 500, height: 500}; 
        this.trialPartBoxes = this.getTrialPartBoxes(data);
    },

    getTrialPartBoxes(data) {
        var parts = SA.HistogramParts.get({cfg: this.cfg, frameSize: this.trialFrameSize, data}),
            svg = SA.HiddenDom.attach(SA.Svg.create({type: 'svg'})),
            getPartBox = part => svg.appendChild(SA.Svg.create(part)).getBBox(),
            partBoxes = SA.Object.mapValues(parts, getPartBox);

        svg.remove();

        return partBoxes;
    },

    resolveHeight() {
        var allocatedHeight = Ext.Array.sum([
            this.trialPartBoxes.chartTitle.height,
            this.trialPartBoxes.xAxisTitle.height,
            this.trialPartBoxes.xLabels.height,
            this.cfg.layout.axisLabelOffset,
            this.cfg.layout.chartPadding * 2, 
            this.cfg.layout.titleOffset * 2 
        ]);

        return this.cfg.layout.chartSize.height - allocatedHeight;
    },

    resolveWidth() {
        var allocatedWidth = Ext.Array.sum([
            this.trialPartBoxes.yAxisTitle.height, 
            this.trialPartBoxes.yLabels.width,
            this.cfg.layout.axisLabelOffset,
            this.cfg.layout.chartPadding * 2, 
            this.cfg.layout.titleOffset,
            getXLabelsOverrun.call(this)
        ]);

        return this.cfg.layout.chartSize.width - allocatedWidth;

        function getXLabelsOverrun() {
            var xLabelsBox = this.trialPartBoxes.xLabels,
                leftOverrun = Math.max(0, this.trialPartBoxes.yLabels.x - xLabelsBox.x),
                rightOverrun = Math.max(0, xLabelsBox.x + xLabelsBox.width - this.trialFrameSize.width);

            return leftOverrun + rightOverrun;
        }
    }
});